import React, { useEffect, useState } from 'react'
import Main from '../../components/Main/Main'
import Title from '../../components/Title'
import { Radio, Tooltip, Typography } from '@material-tailwind/react'
import FuncionarAuto from '../../components/autoComplet/FuncionarAuto'
import {  useForm } from 'react-hook-form'
import Form from '../../components/Main/Form'
import ButtonGlobal from '../../components/ButtonGlobal'
import {  Trash2 } from 'lucide-react'
import Adicionar from '../../components/Buttons/Adicionar'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import TextAreaGlobal from '../../components/TextAreaGlobal'
import { useDispatch, useSelector } from 'react-redux'
import { getFuncionarios, getJustificativaPadrao, postHorasExtra, resetOut } from '../../slices/horasSlice'
import HorariosForms from '../../components/HorasExtras/HorariosForms'
import { calcularHorasTrabalhadas } from './Ultis'
import { formatarDataBr } from '../../ultis/validate'
import MsgInputError from '../../components/MsgInputError'
import MsgSucess from '../../components/MsgSucess'

const HorasExtras = () => {
    const DEFAULT_VALUES = {
      dias_realizados: [{ date: "", start_time: "", lunch_start: "00",lunch_end:"",end_time:"" }],
      employee:"",
      justificativa:"",
      atividadesRealizadas:"",
    };
    const dispatch = useDispatch();
    const { register,setValue,watch, reset,handleSubmit, formState: { errors },control, clearErrors} = useForm({
      defaultValues: DEFAULT_VALUES,
    })
    const {funcionarios,justificativaPadrao,error,successPost,loadingPost} = useSelector((state) => state.horas);
    const horarios = watch()
    const [horas, setHoras] = useState([]);
    
function removerHoras(indexRelatorio, indexDia) {
  dispatch(resetOut())
  setHoras(prevHoras =>
    prevHoras
      .map((relatorio, i) => {
        if (i !== indexRelatorio) return relatorio;

        const novosDias = relatorio.dias_realizados.filter(
          (_, idx) => idx !== indexDia
        );

        // Se ainda tem dias, retorna atualizado
        if (novosDias.length > 0) {
          return {
            ...relatorio,
            dias_realizados: novosDias
          };
        }

        // Se zerou, retorna null (vamos filtrar depois)
        return null;
      })
      .filter(Boolean) // remove os null
  );
}

    const resetDefaultValues = () => {
      reset(DEFAULT_VALUES);
    }

    const resetInfo = () => { 
      dispatch(resetOut())
      setHoras([]);

    }

    useEffect(() => {
      // Sempre que as horas forem atualizadas, ele seta a justificativa do último registro no form, para facilitar a edição caso o usuário queira fazer ajustes e reenviar
      setValue("justificativa", horas[horas.length - 1]?.justificativa || (justificativaPadrao && justificativaPadrao[0]?.descricao));
    }, [horas]);

    useEffect(()=>{
      dispatch(getFuncionarios());
      dispatch(getJustificativaPadrao());
    },[])

    useEffect(()=>{
      if(justificativaPadrao){
        setValue("justificativa", justificativaPadrao[0].descricao);
      }
    },[justificativaPadrao])

    const choiceJustificativa = (index) =>{
      // Ao troca a justificativa, ele seta o valor da justificativa no form e limpa os erros relacionados a justificativa
      const justificativa = justificativaPadrao[index];
      if(justificativa){
        setValue("justificativa", justificativa.descricao);
        clearErrors("justificativa");
      }
    }

    const handleRegister = ()=>{
      setHoras([...horas, horarios])
      resetDefaultValues()
    }

    const onSubmit = async (data) => {
      function transformarEmployeeParaId(lista) {
      return lista.map(item => ({
        ...item,
        employee: item.employee?.id
      }));
      }
      const dadosFormatados = transformarEmployeeParaId(horas);

      dispatch(postHorasExtra(dadosFormatados))
  };
    
  return (
    <Main> 
    <Title>Horas Extras - Formulario</Title>
    <Form>
      <div className="flex flex-row text-white ml-auto pr-[10%]">
      {justificativaPadrao&& justificativaPadrao.map((item,index)=>(
        <Radio 
        onClick={()=>{
          choiceJustificativa(index)
        }}
        name="type" label={<Typography className='dark:text-white'>Exe {index + 1}</Typography>} ripple={true} size={10} color="green" defaultChecked={index === 0 ? true : false}/>
      ))}
      {/* <Radio name="type" label={<Typography className='dark:text-white'>Exe 2</Typography>} ripple={false} size={10} color="green" /> */}
      </div>
  <div className='w-[80%]'>
    <Typography
        color="white"
        variant="h6"
        className="mb-1 text-left font-medium text-black dark:text-white capitalize"
    >
      Funcionario
    </Typography>
      <FuncionarAuto 
      funcionarios={funcionarios}
      name="employee"
      control={control}
      />
    </div>
    <div className='w-[80%] flex gap-5'>
      <TextAreaGlobal text="Justificativa" formCamp="justificativa" register={register} errors={errors} validations={{ required: "Campo obrigatório" }}/>
      <TextAreaGlobal text="Atividade realizada" formCamp="atividadesRealizadas" register={register} errors={errors} validations={{ required: "Campo obrigatório" }}/>
    </div>

    <HorariosForms register={register} control={control} errors={errors}/>

    <Adicionar
      text="Confimar registro"
      click={handleSubmit(handleRegister)}
      // click={handleSubmit(addProduct)}
      // error={Object.keys(errors).length > 0 ? true : false}
    />

      {error && <MsgInputError text={error} />}
        {successPost && (
          <MsgSucess
            text={'PDF GERADO COM SUCESSO!!'}
            reset={resetInfo}
            outText={"---"}
          />
        )}

    </Form>
          <div className=" w-[95%] h-[99%] overflow-auto mx-auto pb-2">
            <Paper
              sx={{
                width: '100%',
                flex:1,
                overflow: 'auto',
                bgcolor: 'transparent',
              }}
            >
              <TableContainer sx={{ maxHeight: '100%' }}>
                <Table stickyHeader aria-label="sticky table" sx={{ textTransform: 'uppercase' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Data</TableCell>
                      <TableCell align="right">Funcionário</TableCell>
                      <TableCell align="right">INCIO/FIM</TableCell>
                      <TableCell align="right">N°.HORAS</TableCell>
                      <TableCell align='right'>
                      <ButtonGlobal
                      disabled={horas.length === 0}
                      click={onSubmit}
                        text="
                          Gerar PDF
                        "
                      loading={loadingPost}
                    />
            </TableCell>
                </TableRow>
                  </TableHead>
                  <TableBody>
              {horas.flatMap((relatorios, index) =>
                relatorios.dias_realizados.map((dia, indexDia) => (
                  <TableRow  key={`${index}-${indexDia}`}>
                    <TableCell>{formatarDataBr(dia.date)}</TableCell>
                    <TableCell align="right">
                      {relatorios.employee.nome}
                    </TableCell>
                    <TableCell align="right">
                      {dia.start_time}/{dia.end_time}
                    </TableCell>
                    <TableCell align="right">
                      {calcularHorasTrabalhadas(dia)}
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip content="Remover">
                        <Trash2
                          className="hover:text-red-500 cursor-pointer ml-auto"
                          onClick={() => removerHoras(index, indexDia)}
                        />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                    ))
                  )}
                </TableBody>
                </Table>
              </TableContainer>
            </Paper>

          </div>
    </Main>
  )
}

export default HorasExtras


